module.exports = __webpack_public_path__ + "static/media/hirum.ab0c4e29.jpeg";